import React from "react";
import InvoiceDiscountsSection from "./InvoiceDiscountsSection";
import InvoiceFeesSection from "./InvoiceFeesSection";
import formatCurrency from "../../../../../../../../utils/helpers/formatCurrency";

export default function ParagraphSectionComp({ invoiceDetails, isManual = false }) {  
  return (
    <div>
      {" "}
      <div style={{ marginTop: "20px" }}>
        <div style={{ fontWeight: "bold", fontSize: "large" }}>
          ITEM DESCRIPTION
        </div>
        <div
          style={{
            border: "1px solid black",
            padding: "5px",
            borderRadius: "5px",
            marginTop: "3px",
          }}
        >
          {invoiceDetails.lineItems?.[0]?.description ||
            invoiceDetails.description}
        </div>
      </div>
      {/* <!--  Discount section  --> */}
      {invoiceDetails.discounts
        ? Boolean(invoiceDetails.discounts?.length) && (
            <InvoiceDiscountsSection invoiceDetails={invoiceDetails} />
          )
        : null}
      {/* <!--  Fees section  --> */}
      {invoiceDetails.discounts
        ? Boolean(invoiceDetails.fees.length) && (
            <InvoiceFeesSection invoiceDetails={invoiceDetails} />
          )
        : null}
      {/* <!-- Grand total --> */}
      <table className="table tw-text-black">
        <tr style={{ border: "0px solid #fff", backgroundColor: "#fff" }}>
          <td style={{ border: "0px solid #fff" }}></td>
          <td style={{ border: "0px solid #fff" }}></td>
          <td
            style={{
              fontWeight: "bold",
              textAlign: "right",
              border: "0px solid #fff",
            }}
          >
            Total
          </td>
          <td
            style={{
              fontWeight: "bold",
              textAlign: "right",
              paddingRight: "20px",
              width: "350px",
            }}
          >
            { formatCurrency(invoiceDetails.amount)}
          </td>
        </tr>
      </table>
    </div>
  );
}
